import { Injectable, computed } from '@angular/core';
import { GtmOtpWarningService } from './gtm-otp-warning.service';

@Injectable({
  providedIn: 'root'
})
export class GtmOtpWarningCardService extends GtmOtpWarningService {
  override funnelStep = computed(() => ({
    funnelStepEvent: {
      ...this.baseFunnelStep$$(),
      error_type: this.error_type
    }
  }));

  override funnelClick = computed(() => ({
    guideClickEvent: {
      component_type: 'text',
      click_text: 'כך נראה כרטיס כאל או דיינרס',
      question_text: 'NA'
    },
    submitClickEvent: {
      component_type: 'button',
      click_text: 'הבנתי, תודה',
      question_text: 'NA'
    }
  }));
}
